// removed by extract-text-webpack-plugin
module.exports = {"container":"_97AMi","button":"_2XEkX"};


//////////////////
// WEBPACK FOOTER
// ./app/components/follow-user-button-mobile/follow-user-button-mobile.scss
// module id = 1607
// module chunks = 0